<template>
  <div
    ref="cursor"
    class="fixed z-100 top-0 left-0 opacity-transition select-none flex items-center justify-center pointer-events-none"
    :class="{ 'opacity-0': !mouseInDocument, blend: mouseInInfo && infoOpen }"
  >
    <img class="w-cursor" :src="src" />
    <span
      class="text-mobile lg:text-laptop 2xl:text-copy opacity-transition index-transform"
      :class="{ 'opacity-0': infoOpen }"
      >{{ realIndex + 1 }} / {{ totalIndex }}</span
    >
  </div>
</template>

<script>
import { mapState } from "vuex";
import { bind } from "@/utils/eventListner";

const white = require("../assets/images/dot-white.svg");
const black = require("../assets/images/dot-black.svg");
const cross = require("../assets/images/cross.svg");

export default {
  name: "CursorDot",

  data: () => ({
    mouseInDocument: false
  }),

  computed: {
    ...mapState([
      "infoOpen",
      "forgroundColor",
      "realIndex",
      "totalIndex",
      "mouseInInfo"
    ]),
    src() {
      if (!this.infoOpen) {
        return this.forgroundColor ? white : black;
      }
      return this.mouseInInfo ? white : cross;
    }
  },

  mounted() {
    bind(window, "mousemove", this.handleMousemove);
    bind(document, "mouseenter", this.handleMouseenter);
    bind(document, "mouseleave", this.handleMouseleave);

    this.req = requestAnimationFrame(this.animatePosition);
  },

  methods: {
    handleMouseenter() {
      this.mouseInDocument = true;
    },
    handleMouseleave() {
      this.mouseInDocument = false;
    },
    handleMousemove(e) {
      if (!this.mouseInDocument) {
        this.mouseInDocument = true;
      }

      this.x = e.clientX;
      this.y = e.clientY;
    },
    animatePosition() {
      this.$refs.cursor.style.cssText = `transform: translate3d(${
        this.x
      }px, ${this.y - 8}px, 0);`;

      this._isDestroyed
        ? cancelAnimationFrame(this.req)
        : requestAnimationFrame(this.animatePosition);
    }
  }
};
</script>

<style scoped>
.opacity-transition {
  transition: 0.5s opacity;
}

.index-transform {
  transform: translateX(12px);
}

.blend {
  mix-blend-mode: difference;
}

.z-100 {
  z-index: 100;
}

@screen lg {
  .w-cursor {
    width: 18px;
  }
}

@screen 2xl {
  .w-cursor {
    width: 21px;
  }
}
</style>
